var map = {
	"./Aid-active.png": "d92c",
	"./Equity-active.png": "cf8f",
	"./authority-active.png": "1850",
	"./key-active.png": "a230",
	"./lecture-active.png": "b53f",
	"./lesson-active.png": "0f09",
	"./midihome2-active.png": "7a18",
	"./organization-active.png": "b906",
	"./personnel-active.png": "4e82",
	"./question-active.png": "2860",
	"./resources-active.png": "58f2",
	"./score-active.png": "d432",
	"./sing-active.png": "1dcc",
	"./test-active.png": "a896"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd10";